const RIBBON_HEIGHT = 48;
const TOOLBAR_HEIGHT = 49;
const TOOLBAR_HEIGHT_FULL_COMPOSE = 56;

export default function getBottomDockingHeight(
    isRibbonShown: boolean,
    isInlineCompose: boolean
): number {
    return (
        (isInlineCompose ? TOOLBAR_HEIGHT : TOOLBAR_HEIGHT_FULL_COMPOSE) +
        (isRibbonShown ? RIBBON_HEIGHT : 0)
    );
}
